import { render, staticRenderFns } from "./ScreeningPage.vue?vue&type=template&id=c5d897e4&scoped=true&"
import script from "./ScreeningPage.vue?vue&type=script&lang=js&"
export * from "./ScreeningPage.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningPage.vue?vue&type=style&index=0&id=c5d897e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d897e4",
  null
  
)

export default component.exports